export default __webpack_public_path__ + "static/media/img_step_hami12.2e26ca97.png";